/* Category grid "Show all / Show less" toggle — shared by cn-categories
   and wl-formats. Data-attribute driven; each section keeps its own classes.
     root   : [data-cat-grid]            (gets `is-expanded` toggled)
     button : [data-cat-toggle]          (+ data-more / data-less labels)
     label  : [data-cat-toggle-text]     (text swapped on toggle) */
(function () {
  function bind(root) {
    var btn = root.querySelector('[data-cat-toggle]');
    if (!btn || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = btn.querySelector('[data-cat-toggle-text]');
      if (label) label.textContent = expanded
        ? (btn.dataset.less || 'Show Less')
        : (btn.dataset.more || 'Show All');
    });
  }
  function boot(scope) {
    (scope || document).querySelectorAll('[data-cat-grid]').forEach(bind);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
